module.exports = __webpack_public_path__ + "img/yellow-card.aa77bbe8.svg";